import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { bridge } from 'shared/src/utils';
import { marketRankingFilterAtom } from '../states/marketRankingFilter.atom';
import { useMarketRankingFilterOptions } from '../queries/useMarketRankingFilterOptions';
import { useMarketRankingTypes } from '../queries/useMarketRankingTypes';

type ApplyFilterNext = {
  selectedCategorySno: number | null;
  selectedAgeValues: (number | null)[];
  selectedStyles: string[];
};

export const useLogApplyFilter = (marketTypeSno: number) => {
  const { data: typesData } = useMarketRankingTypes();
  const { data: filterOptions } =
    useMarketRankingFilterOptions(marketTypeSno);
  const filter = useAtomValue(marketRankingFilterAtom);

  const selectedMarketType =
    filter.selectedMarketType ?? typesData.market_types[0] ?? null;

  return useCallback(
    (next: ApplyFilterNext) => {
      const isFilteredAge = next.selectedAgeValues.length > 0 ? '1' : '0';
      const isFilteredCategory = next.selectedCategorySno !== null ? '1' : '0';
      const isFilteredStyle = next.selectedStyles.length > 0 ? '1' : '0';

      const appliedTabCount = [
        isFilteredAge,
        isFilteredCategory,
        isFilteredStyle,
      ].filter(v => v === '1').length;

      const ageName =
        filterOptions?.ages.find(a => a.value === next.selectedAgeValues[0])
          ?.name ?? '전체 연령';

      const categoryName =
        filterOptions?.category_options.find(
          c => c.sno === next.selectedCategorySno,
        )?.name ?? '전체';

      bridge.logAnalyticsEvent({
        name: 'APPLY_FILTER',
        analytics: {
          SCREEN: 'MARKET_RANKING',
          EVENT_TYPE: 'APPLY_FILTER',
          TYPE: selectedMarketType?.name,
          APPLIED_FILTER_TYPE: {
            AGE: isFilteredAge,
            LOOK: isFilteredStyle,
            CATEGORY: isFilteredCategory,
          },
          APPLIED_FILTER_TAB_COUNTS: appliedTabCount.toString(),
          CATEGORY_SNO: (next.selectedCategorySno ?? -1).toString(),
          CATEGORY_NAME: categoryName,
          IS_FILTERED_CATEGORY: isFilteredCategory,
          IS_FILTERED_STYLE: isFilteredStyle,
          IS_FILTERED_AGE: isFilteredAge,
          AGE: ageName,
          STYLE: `[${next.selectedStyles.join(',')}]`,
        },
      });
    },
    [filterOptions, selectedMarketType?.name],
  );
};
